import { Box, Container, Typography, Divider } from "@mui/material";

export default function PrivacyPolicyPage() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight={800} gutterBottom>
        Datenschutzerklärung
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Stand: {new Date().toLocaleDateString("de-DE")}
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ "& h2": { mt: 4, mb: 1.5 }, "& p": { mb: 1.5 } }}>
        <Typography variant="h6" component="h2">
          1. Verantwortlicher
        </Typography>
        <Typography>
          Christoph Eitelhuber, 86633 Neuburg
        </Typography>

        <Typography variant="h6" component="h2">
          2. Allgemeines zur Datenverarbeitung
        </Typography>
        <Typography>
          Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies
          zur Bereitstellung einer funktionsfähigen Anwendung sowie unserer Inhalte und
          Leistungen erforderlich ist.
        </Typography>

        <Typography variant="h6" component="h2">
          3. Welche Daten wir verarbeiten
        </Typography>
        <Typography>
          Im Rahmen der Nutzung dieser Anwendung verarbeiten wir u. a. Stammdaten (Name,
          Kontaktdaten), Nutzungsdaten (z. B. Trainingsteilnahmen, Punktestände) sowie technische
          Daten (z. B. Zugriffsprotokolle), soweit dies für den Betrieb erforderlich ist.
        </Typography>

        <Typography variant="h6" component="h2">
          4. Rechtsgrundlage
        </Typography>
        <Typography>
          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b (Vertragserfüllung),
          lit. c (rechtliche Verpflichtung) und/oder lit. f (berechtigtes Interesse) DSGVO.
        </Typography>

        <Typography variant="h6" component="h2">
          5. Ihre Rechte
        </Typography>
        <Typography>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
          Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung Ihrer
          personenbezogenen Daten. Wenden Sie sich hierzu an die oben genannte verantwortliche
          Stelle.
        </Typography>

        <Typography variant="h6" component="h2">
          6. Kontakt
        </Typography>
        <Typography>
          Bei Fragen zum Datenschutz wenden Sie sich bitte an: info@dartmin.de
        </Typography>
      </Box>
    </Container>
  );
}
